The additional `WebhookRequest`-specific criteria to filter by.
